import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { IscontrolComponent } from '../iscontrol.component';
import { FormControl } from '@angular/forms';
import { ComponentsService, Outlet2Service } from '@ic-builder/is-base';
import { Store } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'istimesingle',
  templateUrl: './timesingle.component.html',
  styleUrls: ['./timesingle.component.scss'],
})
export class TimesingleComponent
  extends IscontrolComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() label: string;
  @Input() initialValue: string;

  controlid: number;
  formControl: FormControl;

  constructor(
    comp: ComponentsService,
    outlet: Outlet2Service,
    private compserv: ComponentsService,
    store: Store,
    public NgZone: NgZone,
    public dialog: MatDialog,
    public el: ElementRef,
    public cd: ChangeDetectorRef
  ) {
    super(comp, store, outlet, NgZone, dialog, el, cd);
  }

  ngOnInit(): void {
    if (this.formInput) {
      this.controlid = super.initControl(
        this.id.toString() + '.time',
        this.initialValue,
        'time'
      );
      this.formControl = super.getFormControl(this.controlid);
    } else {
      this.formControl = new FormControl(this.initialValue);
    }
  }

  ngAfterViewInit() {
    this.el.nativeElement.querySelector('input').focus();
  }

  controlnameValueChanges(newVal) {
    this.compserv.formcontrols.get(this.controlid.toString()).name = newVal;
  }

  ngOnDestroy() {
    // super.destroyControls([this.controlname])
  }
}
